<template>
  <DialogHeader>
    <Icon name="Alert" :size="22" class="mr-2 text-red-700 stroke-red-700" />
    <div class="text-red-700 -mt-0.5">{{ header }}</div>
  </DialogHeader>
  <DialogContent>
    {{ message }}
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full tablet-h:w-auto" danger @click="close()">
      Okay
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Icon } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { computed, onMounted } from 'vue'
import { analytics } from '@/shared/services/analytics'

const props = defineProps<{
  title?: string
  content?: string
  error?: Error
}>()

const { close } = useDialog()

const header = computed(() => props.title || 'Something went wrong')
const message = computed(
  () => props.content || 'We encountered an error. Please try again later.'
)

onMounted(() => {
  if (props.error) {
    analytics.captureException(
      props.error instanceof Error
        ? props.error
        : new Error(String(props.error))
    )
  }
})
</script>
